// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var operationRouter = {
  path: '/operation',
  component: Layout,
  redirect: '/operation/setting',
  name: 'Operation',
  meta: {
    title: '设置',
    icon: 'clipboard',
    roles: ['admin']
  },
  children: [{
    path: 'setting',
    name: 'setting',
    component: function component() {
      return import('@/views/systemSetting/setting');
    },
    meta: {
      title: '系统设置',
      icon: 'clipboard'
    }
  }, {
    path: 'guide',
    name: 'guide',
    component: function component() {
      return import('@/views/systemSetting/guide');
    },
    meta: {
      title: '配置引导',
      icon: 'clipboard'
    }
  }, {
    path: 'notification',
    name: 'notification',
    component: function component() {
      return import('@/views/systemSetting/notification');
    },
    meta: {
      title: '消息通知',
      icon: 'clipboard'
    }
  }, {
    path: 'tempList',
    name: 'tempList',
    component: function component() {
      return import('@/views/systemSetting/tempList');
    },
    meta: {
      title: '消息模版列表',
      icon: 'clipboard'
    }
  }, {
    path: 'messageAlert',
    name: 'messageAlert',
    alwaysShow: true,
    component: function component() {
      return import('@/views/systemSetting/messageAlert');
    },
    redirect: '/operation/messageAlert/systemAlertModule',
    meta: {
      title: '消息预警',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'systemAlertModule',
      name: 'systemAlertModule',
      component: function component() {
        return import('@/views/systemSetting/messageAlert/systemAlertModule');
      },
      meta: {
        title: '预警模块配置',
        icon: 'clipboard'
      }
    }, {
      path: 'systemMessageTemplate',
      name: 'systemMessageTemplate',
      component: function component() {
        return import('@/views/systemSetting/messageAlert/systemMessageTemplate');
      },
      meta: {
        title: '系统消息模板',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'onePass',
    name: 'onePass',
    component: function component() {
      return import('@/views/sms/smsConfig/index');
    },
    meta: {
      title: '一号通',
      icon: 'clipboard'
    }
  }, {
    path: 'onePassConfig',
    name: 'onePassConfig',
    component: function component() {
      return import('@/views/sms/smsConfig/config');
    },
    meta: {
      title: '一号通配置',
      icon: 'clipboard'
    }
  }, {
    path: 'roleManager',
    name: 'RoleManager',
    component: function component() {
      return import('@/views/systemSetting/administratorAuthority');
    },
    meta: {
      title: '管理权限',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'identityManager',
      component: function component() {
        return import('@/views/systemSetting/administratorAuthority/identityManager');
      },
      name: 'identityManager',
      meta: {
        title: '角色管理',
        icon: ''
      }
    }, {
      path: 'adminList',
      component: function component() {
        return import('@/views/systemSetting/administratorAuthority/adminList');
      },
      name: 'adminList',
      meta: {
        title: '管理员列表',
        icon: ''
      }
    }, {
      path: 'promiseRules',
      component: function component() {
        return import('@/views/systemSetting/administratorAuthority/permissionRules');
      },
      name: 'promiseRules',
      meta: {
        title: '权限规则',
        icon: ''
      }
    }]
  }, {
    path: 'systemSms',
    component: function component() {
      return import('@/views/sms');
    },
    name: 'systemSms',
    meta: {
      title: '短信设置',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'config',
      component: function component() {
        return import('@/views/sms/smsConfig');
      },
      name: 'SmsConfig',
      meta: {
        title: '短信账户',
        noCache: true
      }
    }, {
      path: 'template',
      component: function component() {
        return import('@/views/sms/smsTemplate');
      },
      name: 'SmsTemplate',
      meta: {
        title: '短信模板',
        noCache: true,
        activeMenu: "/operation/onePass"
      }
    }, {
      path: 'pay',
      component: function component() {
        return import('@/views/sms/smsPay');
      },
      name: 'SmsPay',
      meta: {
        title: '短信购买',
        noCache: true,
        activeMenu: "/operation/onePass"
      }
    }, {
      path: 'message',
      component: function component() {
        return import('@/views/sms/smsMessage');
      },
      name: 'SmsMessage',
      meta: {
        title: '短信开关',
        noCache: true
      }
    }]
  }, {
    path: 'design',
    name: 'design',
    alwaysShow: true,
    component: function component() {
      return import('@/views/systemSetting/design');
    },
    meta: {
      title: '页面管理',
      roles: ['admin']
    },
    children: [{
      path: 'viewDesign',
      component: function component() {
        return import('@/views/systemSetting/design/viewDesign');
      },
      name: 'viewDesign',
      meta: {
        title: '页面设计',
        noCache: true
      }
    }, {
      path: 'theme',
      component: function component() {
        return import('@/views/systemSetting/design/theme');
      },
      name: 'theme',
      meta: {
        title: '一键换色',
        noCache: true
      }
    }]
  }, {
    path: 'deliverGoods',
    name: 'deliverGoods',
    alwaysShow: true,
    component: function component() {
      return import('@/views/systemSetting/deliverGoods');
    },
    meta: {
      title: '发货设置',
      roles: ['admin']
    },
    children: [{
      path: 'takeGoods',
      component: function component() {
        return import('@/views/systemSetting/deliverGoods/takeGoods');
      },
      name: 'takeGoods',
      meta: {
        title: '提货设置',
        noCache: true,
        roles: ['admin']
      },
      children: [{
        path: 'deliveryAddress',
        component: function component() {
          return import('@/views/systemSetting/deliverGoods/takeGoods/deliveryAddress');
        },
        name: 'deliveryAddress',
        meta: {
          title: '提货点',
          icon: ''
        }
      }, {
        path: 'collateOrder',
        component: function component() {
          return import('@/views/systemSetting/deliverGoods/takeGoods/collateOrder');
        },
        name: 'collateOrder',
        meta: {
          title: '核销订单',
          icon: ''
        }
      }, {
        path: 'collateUser',
        component: function component() {
          return import('@/views/systemSetting/deliverGoods/takeGoods/collateUser');
        },
        name: 'collateUser',
        meta: {
          title: '核销员',
          icon: ''
        }
      }]
    }, {
      path: 'freightSet',
      component: function component() {
        return import('@/views/systemSetting/deliverGoods/freightSet');
      },
      name: 'freightSet',
      meta: {
        title: '运费模板',
        noCache: true
      }
    }]
  }, {
    path: 'configure',
    name: 'configure',
    component: function component() {
      return import('@/views/systemSetting/configure');
    },
    meta: {
      title: '系统配置',
      icon: ''
    },
    children: [{
      path: 'setting',
      name: 'setting',
      component: function component() {
        return import('@/views/systemSetting/configure/setting');
      },
      meta: {
        title: '系统配置',
        icon: ''
      }
    }, {
      path: 'interface',
      name: 'interface',
      component: function component() {
        return import('@/views/systemSetting/configure/interface');
      },
      meta: {
        title: '接口配置',
        icon: ''
      }
    }, {
      path: 'baidu',
      name: 'baidu',
      component: function component() {
        return import('@/views/systemSetting/configure/baidu');
      },
      meta: {
        title: '百度定位配置',
        icon: ''
      }
    }]
  }, {
    path: 'userSetting',
    name: 'userSetting',
    component: function component() {
      return import('@/views/systemSetting/userSetting');
    },
    meta: {
      title: '用户管理',
      icon: ''
    },
    children: [{
      path: 'account',
      name: 'account',
      component: function component() {
        return import('@/views/systemSetting/userSetting/account');
      },
      meta: {
        title: '商户账号',
        icon: ''
      }
    }, {
      path: 'unionDashboard',
      name: 'unionDashboard',
      component: function component() {
        return import('@/views/systemSetting/userSetting/union/dashboard');
      },
      meta: {
        title: '工会管理中心',
        icon: ''
      }
    }, {
      path: 'union',
      name: 'union',
      component: function component() {
        return import('@/views/systemSetting/userSetting/union');
      },
      meta: {
        title: '工会信息',
        icon: ''
      }
    }, {
      path: 'unionMember',
      name: 'unionMember',
      component: function component() {
        return import('@/views/systemSetting/userSetting/unionMember');
      },
      meta: {
        title: '工会会员',
        icon: ''
      }
    }, {
      path: 'unionSync',
      name: 'unionSync',
      component: function component() {
        return import('@/views/systemSetting/userSetting/union/sync');
      },
      meta: {
        title: '数据同步',
        icon: ''
      }
    }, {
      path: 'business',
      name: 'businessManagement',
      component: function component() {
        return import('@/views/systemSetting/userSetting/business/index');
      },
      meta: {
        title: '商户管理',
        icon: ''
      }
    }, {
      path: 'store',
      name: 'storeManagement',
      component: function component() {
        return import('@/views/systemSetting/userSetting/store/index');
      },
      meta: {
        title: '门店管理',
        icon: ''
      },
      hidden: true
    }, {
      path: 'sync',
      name: 'syncManagement',
      component: function component() {
        return import('@/views/systemSetting/userSetting/sync/index');
      },
      meta: {
        title: '数据同步',
        icon: ''
      }
    }]
  }, {
    path: 'journal',
    name: 'journal',
    component: function component() {
      return import('@/views/systemSetting/journal');
    },
    meta: {
      title: '日志管理',
      icon: ''
    },
    children: [{
      path: 'errRecord',
      name: 'errRecord',
      component: function component() {
        return import('@/views/systemSetting/journal/errRecord');
      },
      meta: {
        title: '错误日志',
        icon: ''
      }
    }]
  }]
};
export default operationRouter; //collate